import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field, FieldArray, isDirty, reduxForm } from 'redux-form';

import Typography from '@material-ui/core/Typography';

import {
  DropDown,
  ExpansionPanelWrapper,
  FormActionButtons,
  IntegrationsInputFields
} from 'components';

import {
  deleteIntegrationSettings,
  deleteTrekksoftCategory
} from 'actions/userSettings';
import validate from './validate';
import { BOOKING, EXPEDIA, TREKKSOFT } from 'constants/userSettings';

import { useStyles } from './styles';

const initialValues = {
  integrations: []
};

const PLATFORMS = ['Trekksoft', 'Expedia', 'BOOKING'];

const Integrations = ({
  handleSubmit,
  deleteIntegrationInfo,
  deleteCategoriesInfo,
  integrationSettingsForm,
  trekkSoftCategoriesMapping,
  isDirty,
  isDirtyCategoriesForm
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const integrations = integrationSettingsForm.values.integrations;

  const getAvailableIntegrationPlatforms = index => {
    const createdPlatforms = integrationSettingsForm.values.integrations.map(
      item => item.integrationPlatform
    );
    const currentPlatform =
      integrationSettingsForm.values.integrations[index].integrationPlatform;

    if (currentPlatform)
      return [
        currentPlatform,
        ...PLATFORMS.filter(x => !createdPlatforms.includes(x))
      ];
    return PLATFORMS.filter(x => !createdPlatforms.includes(x));
  };

  const onAddHandler = (fields, id) => {
    fields.push({
      id: id,
      integrationPlatform: ''
    });
  };

  const onDeleteTrekSoftCategoriesHandler = () => {
    const categories =
      trekkSoftCategoriesMapping.values.trekkSoftCategoriesMapping;
    categories.map(item => {
      if (item.isCreated) deleteCategoriesInfo(item.id);
    });
  };

  const onDeleteHandler = item => {
    deleteIntegrationInfo(item.id, item.integrationPlatform);
    onDeleteTrekSoftCategoriesHandler();
  };

  const onDeleteAllHandler = () => {
    const integration = integrationSettingsForm.values.integrations[0];
    if (integration.id) {
      deleteIntegrationInfo(integration.id, integration.integrationPlatform);
      onDeleteTrekSoftCategoriesHandler();
    }
  };

  const isDisabledPlatform = fieldObj => {
    return fieldObj && fieldObj.id >= 0;
  };

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('Integrations')}
      </Typography>
      <form onSubmit={handleSubmit}>
        <FieldArray
          name="integrations"
          component={ExpansionPanelWrapper}
          isAddDeleteActions={true}
          add={onAddHandler}
          remove={onDeleteHandler}
          removeAll={onDeleteAllHandler}
          isHiddenAddNewButton={integrations.length >= PLATFORMS.length}
          getTitle={item => item.integrationPlatform}
          tabName="integration"
          tabNameAll="all integrations"
          children={(field, index, meta, fieldObj) => (
            <div className={classes.row}>
              <Field
                name={`${field}.integrationPlatform`}
                className={classes.input}
                list={getAvailableIntegrationPlatforms(index)}
                label="Integration platform *"
                placeholder="Choose integration platform"
                disabled={isDisabledPlatform(fieldObj)}
                component={DropDown}
              />
              {fieldObj.integrationPlatform === TREKKSOFT && (
                <IntegrationsInputFields
                  field={field}
                  integrationPlatform="Trekksoft"
                />
              )}
              {fieldObj.integrationPlatform === EXPEDIA && (
                <IntegrationsInputFields
                  field={field}
                  integrationPlatform="Expedia"
                />
              )}
              {fieldObj.integrationPlatform === BOOKING && (
                <IntegrationsInputFields
                  field={field}
                  integrationPlatform="Expedia"
                />
              )}
            </div>
          )}
        />
        <FormActionButtons
          isDisabledAction={!isDirty && !isDirtyCategoriesForm}
          cancelPath="/settings"
          actionLabel="Save"
        />
      </form>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  deleteIntegrationInfo: (id, item) =>
    dispatch(deleteIntegrationSettings(id, item)),
  deleteCategoriesInfo: id => dispatch(deleteTrekksoftCategory(id))
});

const mapStateToProps = state => ({
  integrationSettingsForm: state.form.integrationSettingsForm,
  trekkSoftCategoriesMapping: state.form.trekkSoftCategoriesMapping,
  isDirty: isDirty('integrationSettingsForm')(state),
  isDirtyCategoriesForm: isDirty('trekkSoftCategoriesMapping')(state)
});

export default reduxForm({
  form: 'integrationSettingsForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  touchOnBlur: false,
  validate,
  initialValues
})(connect(mapStateToProps, mapDispatchToProps)(Integrations));
